import { Pipe, PipeTransform } from "@angular/core";

// This is used to bind our typeaheads instead of calling a function in the html

//  Update:
//  This is used to bind functions to services/components/etc.  Allows you to access
//  the contents of the bound object in the function that you're passing to a child
//  component.  We should consider renaming it to something more generic.  Additionally,
//  this should only be used when other options fail (ex: Outputs/Emitters/etc). - CS May 7 2024
@Pipe({
    name: 'typeaheadBinder',
    pure: true,
    standalone: false
})
export class TypeaheadBinderPipe implements PipeTransform {
  transform(typeahead: any, obj: any): any {
    return typeahead.bind(obj)
  }
}
